<section mat-dialog-content class="message-dialog-content">
	<icon *ngIf="data.hasCloseIcon" type="times" class="close-icon" (click)="closeDialog()"></icon>
	<h1 mat-dialog-title class="text-medium title">{{ data.message.title }}</h1>
	<p class="description">{{ data.message.description }}</p>
	<section *ngIf="data.message.actions" class="action-panel">
		<button dz-button *ngFor="let action of data.message.actions" (click)="directToPage(action)" [track-event]="getTrackMsg(action.label)" cdkFocusInitial>
			{{ action.label }}
		</button>
	</section>
</section>
